import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { imgTema6 } from '../../../assets/tema6';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	dialogEleven: 12,
	dialogTwelve: 13,
	dialogThirteen: 14,
	dialogFourteen: 15,
	dialogFifteen: 16,
	dialogSixteen: 17,
	dialogSeventeen: 18,
	dialogEighteen: 19,
	dialogNineteen: 20,
	dialogTwenty: 21,
	dialogTwentyOne: 22,
	dialogTwentyTwo: 23,
	dialogTwentyThree: 24,
	dialogTwentyFour: 25,
	dialogTwentyFive: 26,
	win: 27
};

const stepThree = {

}

export const Theme6SubtopicFourActivityOne = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema6.activities.subtema4], 1);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 6 sub 4 act 1");
			ObserverEmitter.emit(EVENTS.tema6.topic4.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a01)
	})

	ObserverEmitter.on(EVENTS.tema6.topic4.listenScene, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema6.topic4.initScene, 1);
						ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "move_desk_final");
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: OXXO Pay." />
					<DialogBarNew
						dialog={`Es hora de adentrarnos dentro de un tema fascinante, ¡OXXO Pay!`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							// ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 4. OXXO Pay"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a02)
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Con “OXXO PAY” ayudaremos a nuestros Clientes a pagar lo que compran por internet.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a03)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={`Veamos los pasos para realizar el cobro con "OXXO PAY".`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a04)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "expand_desk");
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full pt-12 flex justify-center items-center">
						<div className="w-[224px] h-[280px] md:w-[450px] md:h-[600px] gradiantBlueClient rounded-2xl border-[1px] border-white p-2">
							<div className="bg-red_primary w-full h-[32px] md:h-[40px] rounded-lg flex justify-center items-center">
								<p className="text-white text-[14px] md:text-[24px]">Paso 1</p>
							</div>
							<div className="h-[calc(100%-32px)] md:h-[calc(100%-40px)] md:p-7">
								<div className="w-full h-full py-3">
									<img className="h-full w-full object-contain" src={imgTema6.QuestionCard3} alt="Cliente con cajera OXXO" />
								</div>
							</div>
						</div>
					</div>
					<DialogBarNew
						dialog={`Solicita el número de referencia, “OXXO PAY” del Cliente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a05)
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<DoubleCard
						header1={'1. OXXO PAY'}
						img1={imgTema6.miniMonitor1}
						text1={`Tecleando desde la pantalla de ventas la "referencia OXXO Pay"`}
						header2={'2. OXXO PAY'}
						img2={imgTema6.miniMonitor2}
						text2={`Entrando desde el menú de cobro de servicios."`}
					/>

					<DialogBarNew
						dialog={`Para ingresar a OXXO PAY existen 2 maneras:`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a06)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "move_desk");
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={`Observemos cómo ingresar a OXXO PAY, tecleando desde la pantalla.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a07)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "monitor_1")
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						dialog={`Teclea la referencia de OXXO PAY.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a08)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "monitor_2")
							setUiToShow(steps.dialogEight);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEight && (
				<>
					<DialogBarNew
						dialog={`Informa al Cliente de la comisión, si acepta da clic en "Si".`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a09)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "button_hidden")
							setUiToShow(steps.dialogNine);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogNine && (
				<>
					<DialogBarNew
						dialog={`Se abrirá el aplicativo de pagos en línea OXXO PAY.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a10)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "move_desk")
							setUiToShow(steps.dialogTen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<DialogBarNew
						dialog={`¡Excelente! Ahora observemos cómo ingresar a OXXO PAY desde el menú de cobro de servicios.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a11)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "monitor_4")
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "button_visible")
							setUiToShow(steps.dialogEleven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEleven && (
				<>
					<DialogBarNew
						dialog={`Selecciona "servicios" en la pantalla de ventas.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a12)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "monitor_5")
							setUiToShow(steps.dialogTwelve);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwelve && (
				<>
					<DialogBarNew
						dialog={`Selecciona OXXO PAY.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a13)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "monitor_6")
							setUiToShow(steps.dialogThirteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThirteen && (
				<>
					<DialogBarNew
						dialog={`Selecciona OXXO PAY de nuevo.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a14)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "monitor_2")
							setUiToShow(steps.dialogFourteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFourteen && (
				<>
					<DialogBarNew
						dialog={`Informa al Cliente de la comisión, si acepta da clic en "Si".`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a15)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "monitor_7")
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "button_hidden")
							setUiToShow(steps.dialogFifteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFifteen && (
				<>
					<DialogBarNew
						dialog={`Se abrirá el aplicativo de pagos en línea OXXO PAY.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a16)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "button_visible")
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "monitor_3")
							setUiToShow(steps.dialogSixteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSixteen && (
				<>
					<DialogBarNew
						dialog={`Captura la referencia, de OXXO PAY.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a17)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "button_position")
							setUiToShow(steps.dialogSeventeen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeventeen && (
				<>
					<DialogBarNew
						dialog={`Después de capturar la referencia, da clic en "Consulta" para continuar con el proceso.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a18)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "move_desk")
							setUiToShow(steps.dialogEighteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEighteen && (
				<>
					<DialogBarNew
						dialog={`En caso de haber ingresado desde el menú de servicios, deberás capturar la referencia OXXO PAY, si ingresaste desde la pantalla de ventas no será necesario.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a19)
							setUiToShow(steps.dialogNineteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogNineteen && (
				<>
					<DialogBarNew
						dialog={`¡Muy bien! A partir de este punto, el proceso es el mismo, ya sea que hayas ingresado desde el menú de servicios o desde la pantalla de ventas.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a20)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "monitor_8")
							setUiToShow(steps.dialogTwenty);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwenty && (
				<>
					<DialogBarNew
						dialog={`Confirma el número de referencia con Cliente, y da clic en "Procesar" para continuar.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a21)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "monitor_9")
							setUiToShow(steps.dialogTwentyOne);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentyOne && (
				<>
					<DialogBarNew
						dialog={`Indica al Cliente que ya no existirán cancelaciones una vez que confirmes, si accede, da clic en "Sí".`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a22)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "move_keyboard_1")
							setUiToShow(steps.dialogTwentyTwo);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentyTwo && (
				<>
					<DialogBarNew
						dialog={`Oprime la tecla "Enter" para cerrar la transacción del Cliente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a23)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "move_keyboard_2")
							setUiToShow(steps.dialogTwentyThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentyThree && (
				<>
					<DialogBarNew
						dialog={`Oprime la tecla "Subtotalizar" para cerrar la venta.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a24)
							ObserverEmitter.emit(EVENTS.tema6.topic4.actScene, "move_desk_final")
							setUiToShow(steps.dialogTwentyFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentyFour && (
				<>
					<DialogBarNew
						dialog={`Marca en la pantalla la cantidad con la que el Cliente te pagó, entrega el cambio y su ticket.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub04.sub4_act1_a25)
							setUiToShow(steps.dialogTwentyFive);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwentyFive && (
				<>
					<DialogBarNew
						dialog={`Es importante resaltar que el pago puede ser en tarjeta y efectivo, el pago es al instante, y se puede realizar de lunes a domingo las 24 horas.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={0}
						dialogModal={`Ahora conoces los pasos para realizar el cobro con "OXXO PAY".`}
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema6.activities.subtema4
								})
							);
							navigator("/home6/tema6/subtema4/activityTwo");
						}}
					/>
				</>
			)}
		</>
	)
}

const DoubleCard = ({ img1, img2, text1, text2, header1, header2 }) => {
	return (
		<>
			<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
			<div className="fixed z-10 h-full w-full p-6 flex justify-center items-center">
				<div className="fixed z-10 h-full w-full flex justify-center items-center gap-3 md:gap-9">
					<div className="w-[220px] h-[272px] md:w-[400px] md:h-[500px] gradiantBlueClient rounded-2xl border-[1px] border-white p-2 md:p-6 flex flex-col justify-between items-center">
						<div className="bg-red_primary w-full h-[32px] md:h-[40px] p-1 rounded-lg flex justify-center items-center">
							<p className="text-white font-semibold text-[14px] md:text-[24px]">{header1}</p>
						</div>
						<div className="h-[140px] md:h-[308px] md:p-7">
							<div className="w-full h-full py-3">
								<img className="h-full w-full object-contain" src={img1} alt="Cliente con cajera OXXO" />
							</div>
						</div>
						<div className='h-[60px] w-full md:h-[92px] bg-white text-xs md:text-base text-center p-2 md:p-4 rounded-lg md:rounded-xl flex justify-center items-center'>
							<p>{text1}</p>
						</div>
					</div>
					<div className="w-[220px] h-[272px] md:w-[400px] md:h-[500px] gradiantBlueClient rounded-2xl border-[1px] border-white p-2 md:p-6 flex flex-col justify-between items-center">
						<div className="bg-red_primary w-full h-[32px] md:h-[40px] p-1 rounded-lg flex justify-center items-center">
							<p className="text-white font-semibold text-[14px] md:text-[24px]">{header2}</p>
						</div>
						<div className="h-[140px] md:h-[308px]  md:p-7">
							<div className="w-full h-full py-3">
								<img className="h-full w-full object-contain" src={img2} alt="Cliente con cajera OXXO" />
							</div>
						</div>
						<div className='h-[60px] w-full md:h-[92px] bg-white text-xs md:text-base text-center p-2 md:p-4 rounded-lg md:rounded-xl flex justify-center items-center'>
							<p>{text2}</p>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}